import { useMutation } from 'react-query';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import useForm from '../../lib/hooks/useForm';
import { resetPassword } from './data';
import i18n from '../../app/i18n';
import { useNotification } from '../../shared/Notification/useNotification';

const validationSchema = yup.object({
  email: yup.string().required(i18n.t('resetPassword:emailRequired')),
});

const useSignIn = () => {
  const { showSuccess } = useNotification();
  const { t } = useTranslation(['shared', 'resetPassword']);
  const { mutate } = useMutation(resetPassword);

  const onSubmit = values => {
    mutate(values, {
      onSuccess: () => {
        Swal.close();
        showSuccess({
          title: t('resetPassword:processReset'),
          content: t('resetPassword:checkEmail'),
        });
      },
    });
  };

  const initialValues = {
    email: '',
  };

  return useForm({
    initialValues,
    onSubmit,
    validationSchema,
  });
};

export default useSignIn;
